<form [formGroup]="form" (ngSubmit)="submit()">
	<nz-form-item>
		<nz-form-label [nzSpan]="6" nzRequired>Bank deposit amount</nz-form-label>
		<nz-form-control [nzSpan]="18" nzErrorTip="Please enter the bank deposit amount">
			<nz-input-group nzPrefix="R">
				<input nz-input type="number" min="0" step="0.01" placeholder="0.00" formControlName="amount" />
			</nz-input-group>
		</nz-form-control>
	</nz-form-item>

	<div class="d-flex justify-content-end gap-2">
		<button nz-button nzType="default" type="button" (click)="cancel()">Cancel</button>
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Confirm</button>
	</div>
</form>
